module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"products_tabs":{"tabs":{"comparisons":{"title":"Vergleiche (%{count})"},"portfolios":{"title":"Portfolios (%{count})"},"watchlist":{"title":"Watchlist (%{count})"}},"title":"Meine Produkte"}}}}}}')
  delete Component.options._Ctor
}
